/* eslint-disable camelcase */
import Template1_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_blue/template_thumbnail_1.png';

import Template1_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_blue/template_thumbnail_2.png';
import Template1_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_blue/template_thumbnail_3.png';
import Template1_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_blue/template_thumbnail_4.png';
import Template1_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_blue/template_thumbnail_5.png';
import Template1_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_blue/template_thumbnail_6.png';
import Template1_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_blue/template_thumbnail_7.png';
import Template1_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_blue/template_thumbnail_8.png';
import Template1_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_blue/template_thumbnail_9.png';
import Template1_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_blue/template_thumbnail_10.png';

import Template2_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_gray/template_thumbnail_1.png';
import Template2_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_gray/template_thumbnail_2.png';
import Template2_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_gray/template_thumbnail_3.png';
import Template2_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_gray/template_thumbnail_4.png';
import Template2_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_gray/template_thumbnail_5.png';
import Template2_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_gray/template_thumbnail_6.png';
import Template2_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_gray/template_thumbnail_7.png';
import Template2_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_gray/template_thumbnail_8.png';
import Template2_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_gray/template_thumbnail_9.png';
import Template2_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_gray/template_thumbnail_10.png';

import Template3_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_geometry_blue/template_thumbnail_1.png';
import Template3_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_geometry_blue/template_thumbnail_2.png';
import Template3_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_geometry_blue/template_thumbnail_3.png';
import Template3_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_geometry_blue/template_thumbnail_4.png';
import Template3_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_geometry_blue/template_thumbnail_5.png';
import Template3_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_geometry_blue/template_thumbnail_6.png';
import Template3_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_geometry_blue/template_thumbnail_7.png';
import Template3_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_geometry_blue/template_thumbnail_8.png';
import Template3_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_geometry_blue/template_thumbnail_9.png';
import Template3_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_geometry_blue/template_thumbnail_10.png';

import Template4_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_minimalist_dark/template_thumbnail_1.png';
import Template4_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_minimalist_dark/template_thumbnail_2.png';
import Template4_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_minimalist_dark/template_thumbnail_3.png';
import Template4_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_minimalist_dark/template_thumbnail_4.png';
import Template4_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_minimalist_dark/template_thumbnail_5.png';
import Template4_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_minimalist_dark/template_thumbnail_6.png';
import Template4_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_minimalist_dark/template_thumbnail_7.png';
import Template4_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_minimalist_dark/template_thumbnail_8.png';
import Template4_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_minimalist_dark/template_thumbnail_9.png';
import Template4_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_minimalist_dark/template_thumbnail_10.png';

import Template5_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_cube_green/template_thumbnail_1.png';
import Template5_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_cube_green/template_thumbnail_2.png';
import Template5_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_cube_green/template_thumbnail_3.png';
import Template5_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_cube_green/template_thumbnail_4.png';
import Template5_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_cube_green/template_thumbnail_5.png';
import Template5_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_cube_green/template_thumbnail_6.png';
import Template5_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_cube_green/template_thumbnail_7.png';
import Template5_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_cube_green/template_thumbnail_8.png';
import Template5_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_cube_green/template_thumbnail_9.png';
import Template5_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_cube_green/template_thumbnail_10.png';

import Template6_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_geometry_green/template_thumbnail_1.png';
import Template6_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_geometry_green/template_thumbnail_2.png';
import Template6_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_geometry_green/template_thumbnail_3.png';
import Template6_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_geometry_green/template_thumbnail_4.png';
import Template6_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_geometry_green/template_thumbnail_5.png';
import Template6_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_geometry_green/template_thumbnail_6.png';
import Template6_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_geometry_green/template_thumbnail_7.png';
import Template6_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_geometry_green/template_thumbnail_8.png';
import Template6_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_geometry_green/template_thumbnail_9.png';
import Template6_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_geometry_green/template_thumbnail_10.png';

import Template7_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_blue/template_thumbnail_1.png';
import Template7_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_blue/template_thumbnail_2.png';
import Template7_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_blue/template_thumbnail_3.png';
import Template7_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_blue/template_thumbnail_4.png';
import Template7_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_blue/template_thumbnail_5.png';
import Template7_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_blue/template_thumbnail_6.png';
import Template7_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_blue/template_thumbnail_7.png';
import Template7_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_blue/template_thumbnail_8.png';
import Template7_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_blue/template_thumbnail_9.png';
import Template7_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_blue/template_thumbnail_10.png';

import Template8_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_darkgold/template_thumbnail_1.png';
import Template8_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_darkgold/template_thumbnail_2.png';
import Template8_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_darkgold/template_thumbnail_3.png';
import Template8_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_darkgold/template_thumbnail_4.png';
import Template8_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_darkgold/template_thumbnail_5.png';
import Template8_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_darkgold/template_thumbnail_6.png';
import Template8_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_darkgold/template_thumbnail_7.png';
import Template8_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_darkgold/template_thumbnail_8.png';
import Template8_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_darkgold/template_thumbnail_9.png';
import Template8_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_darkgold/template_thumbnail_10.png';

import Template9_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_gray/template_thumbnail_1.png';
import Template9_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_gray/template_thumbnail_2.png';
import Template9_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_gray/template_thumbnail_3.png';
import Template9_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_gray/template_thumbnail_4.png';
import Template9_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_gray/template_thumbnail_5.png';
import Template9_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_gray/template_thumbnail_6.png';
import Template9_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_gray/template_thumbnail_7.png';
import Template9_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_gray/template_thumbnail_8.png';
import Template9_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_gray/template_thumbnail_9.png';
import Template9_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_gray/template_thumbnail_10.png';

import Template10_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_green/template_thumbnail_1.png';
import Template10_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_green/template_thumbnail_2.png';
import Template10_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_green/template_thumbnail_3.png';
import Template10_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_green/template_thumbnail_4.png';
import Template10_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_green/template_thumbnail_5.png';
import Template10_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_green/template_thumbnail_6.png';
import Template10_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_green/template_thumbnail_7.png';
import Template10_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_green/template_thumbnail_8.png';
import Template10_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_green/template_thumbnail_9.png';
import Template10_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_green/template_thumbnail_10.png';

import Template11_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_purple/template_thumbnail_1.png';
import Template11_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_purple/template_thumbnail_2.png';
import Template11_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_purple/template_thumbnail_3.png';
import Template11_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_purple/template_thumbnail_4.png';
import Template11_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_purple/template_thumbnail_5.png';
import Template11_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_purple/template_thumbnail_6.png';
import Template11_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_purple/template_thumbnail_7.png';
import Template11_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_purple/template_thumbnail_8.png';
import Template11_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_purple/template_thumbnail_9.png';
import Template11_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_purple/template_thumbnail_10.png';

import Template12_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_ray_blue/template_thumbnail_1.png';
import Template12_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_ray_blue/template_thumbnail_2.png';
import Template12_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_ray_blue/template_thumbnail_3.png';
import Template12_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_ray_blue/template_thumbnail_4.png';
import Template12_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_ray_blue/template_thumbnail_5.png';
import Template12_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_ray_blue/template_thumbnail_6.png';
import Template12_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_ray_blue/template_thumbnail_7.png';
import Template12_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_ray_blue/template_thumbnail_8.png';
import Template12_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_ray_blue/template_thumbnail_9.png';
import Template12_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_ray_blue/template_thumbnail_10.png';

import Template13_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_pink/template_thumbnail_1.png';
import Template13_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_pink/template_thumbnail_2.png';
import Template13_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_pink/template_thumbnail_3.png';
import Template13_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_pink/template_thumbnail_4.png';
import Template13_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_pink/template_thumbnail_5.png';
import Template13_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_pink/template_thumbnail_6.png';
import Template13_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_pink/template_thumbnail_7.png';
import Template13_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_pink/template_thumbnail_8.png';
import Template13_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_pink/template_thumbnail_9.png';
import Template13_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_pink/template_thumbnail_10.png';

import Template14_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_purple/template_thumbnail_1.png';
import Template14_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_purple/template_thumbnail_2.png';
import Template14_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_purple/template_thumbnail_3.png';
import Template14_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_purple/template_thumbnail_4.png';
import Template14_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_purple/template_thumbnail_5.png';
import Template14_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_purple/template_thumbnail_6.png';
import Template14_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_purple/template_thumbnail_7.png';
import Template14_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_purple/template_thumbnail_8.png';
import Template14_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_purple/template_thumbnail_9.png';
import Template14_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_purple/template_thumbnail_10.png';

import Template15_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_red/template_thumbnail_1.png';
import Template15_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_red/template_thumbnail_2.png';
import Template15_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_red/template_thumbnail_3.png';
import Template15_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_red/template_thumbnail_4.png';
import Template15_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_red/template_thumbnail_5.png';
import Template15_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_red/template_thumbnail_6.png';
import Template15_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_red/template_thumbnail_7.png';
import Template15_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_red/template_thumbnail_8.png';
import Template15_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_red/template_thumbnail_9.png';
import Template15_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_red/template_thumbnail_10.png';

import Template16_1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_yellow/template_thumbnail_1.png';
import Template16_2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_yellow/template_thumbnail_2.png';
import Template16_3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_yellow/template_thumbnail_3.png';
import Template16_4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_yellow/template_thumbnail_4.png';
import Template16_5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_yellow/template_thumbnail_5.png';
import Template16_6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_yellow/template_thumbnail_6.png';
import Template16_7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_yellow/template_thumbnail_7.png';
import Template16_8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_yellow/template_thumbnail_8.png';
import Template16_9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_yellow/template_thumbnail_9.png';
import Template16_10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_yellow/template_thumbnail_10.png';

import { IStandardTemplate } from '@src/slide/application/service/change-template-service/index.interface';
import { STSlideLayoutType } from '@tencent/slide-sdk-model';
import i18n from '@i18next/i18n';
import {
    BODY_PLACEHOLDER,
    CENTER_TITLE_PLACEHOLDER,
    CONTENT_PLACEHOLDER,
    DATE_PLACEHOLDER,
    FOOTER_PLACEHOLDER,
    PICTURE_PLACEHOLDER,
    SLIDE_NUMBER_PLACEHOLDER,
    SUB_TITLE_PLACEHOLDER,
    TITLE_PLACEHOLDER,
} from '@src/slide/application/service/change-template-service';

export interface ITemplate {
    id: string;
    cover?: string;
    imgList?: string[];
    needVip?: boolean;
}

export const STANDARD_TEMPLATE: IStandardTemplate = {
    [STSlideLayoutType.title]: {
        standardTitle: i18n.t('标题幻灯片'),
        alias: [i18n.t('封面')],
        placeHolders: [
            CENTER_TITLE_PLACEHOLDER,
            SUB_TITLE_PLACEHOLDER,
            DATE_PLACEHOLDER,
            FOOTER_PLACEHOLDER,
            SLIDE_NUMBER_PLACEHOLDER,
        ],
    },
    [STSlideLayoutType.obj]: {
        standardTitle: i18n.t('标题和内容'),
        placeHolders: [
            TITLE_PLACEHOLDER,
            CONTENT_PLACEHOLDER,
            DATE_PLACEHOLDER,
            FOOTER_PLACEHOLDER,
            SLIDE_NUMBER_PLACEHOLDER,
        ],
    },
    [STSlideLayoutType.secHead]: {
        standardTitle: i18n.t('节标题'),
        placeHolders: [
            TITLE_PLACEHOLDER,
            BODY_PLACEHOLDER,
            DATE_PLACEHOLDER,
            FOOTER_PLACEHOLDER,
            SLIDE_NUMBER_PLACEHOLDER,
        ],
    },
    [STSlideLayoutType.twoObj]: {
        standardTitle: i18n.t('两栏内容'),
        placeHolders: [
            TITLE_PLACEHOLDER,
            CONTENT_PLACEHOLDER,
            CONTENT_PLACEHOLDER,
            DATE_PLACEHOLDER,
            FOOTER_PLACEHOLDER,
            SLIDE_NUMBER_PLACEHOLDER,
        ],
    },
    [STSlideLayoutType.twoTxTwoObj]: {
        standardTitle: i18n.t('比较'),
        placeHolders: [
            TITLE_PLACEHOLDER,
            BODY_PLACEHOLDER,
            CONTENT_PLACEHOLDER,
            BODY_PLACEHOLDER,
            BODY_PLACEHOLDER,
            DATE_PLACEHOLDER,
            FOOTER_PLACEHOLDER,
            SLIDE_NUMBER_PLACEHOLDER,
        ],
    },
    [STSlideLayoutType.blank]: {
        standardTitle: i18n.t('空白'),
        placeHolders: [DATE_PLACEHOLDER, FOOTER_PLACEHOLDER, SLIDE_NUMBER_PLACEHOLDER],
    },
    [STSlideLayoutType.titleOnly]: {
        standardTitle: i18n.t('仅标题'),
        placeHolders: [TITLE_PLACEHOLDER, DATE_PLACEHOLDER, FOOTER_PLACEHOLDER, SLIDE_NUMBER_PLACEHOLDER],
    },
    [STSlideLayoutType.objTx]: {
        standardTitle: i18n.t('内容与标题'),
        placeHolders: [
            TITLE_PLACEHOLDER,
            CONTENT_PLACEHOLDER,
            BODY_PLACEHOLDER,
            DATE_PLACEHOLDER,
            FOOTER_PLACEHOLDER,
            SLIDE_NUMBER_PLACEHOLDER,
        ],
    },
    [STSlideLayoutType.picTx]: {
        standardTitle: i18n.t('图片与标题'),
        placeHolders: [
            TITLE_PLACEHOLDER,
            PICTURE_PLACEHOLDER,
            BODY_PLACEHOLDER,
            DATE_PLACEHOLDER,
            FOOTER_PLACEHOLDER,
            SLIDE_NUMBER_PLACEHOLDER,
        ],
    },
    [STSlideLayoutType.vertTx]: {
        standardTitle: i18n.t('标题和竖排文字'),
        placeHolders: [
            TITLE_PLACEHOLDER,
            BODY_PLACEHOLDER,
            DATE_PLACEHOLDER,
            FOOTER_PLACEHOLDER,
            SLIDE_NUMBER_PLACEHOLDER,
        ],
    },
    [STSlideLayoutType.vertTitleAndTx]: {
        standardTitle: i18n.t('竖排标题与文本'),
        placeHolders: [
            TITLE_PLACEHOLDER,
            BODY_PLACEHOLDER,
            DATE_PLACEHOLDER,
            FOOTER_PLACEHOLDER,
            SLIDE_NUMBER_PLACEHOLDER,
        ],
    },
};

export const TEMPLATE_LIST: ITemplate[] = [
    {
        id: '3wr1pbmdtjrh3jjfzwr75chiya',
        cover: Template7_1,
        imgList: [
            Template7_2,
            Template7_3,
            Template7_4,
            Template7_5,
            Template7_6,
            Template7_7,
            Template7_8,
            Template7_9,
            Template7_10,
        ],
    },
    {
        id: 'gmkecq1xcbgpbesf4w4jrcmz4r',
        cover: Template8_1,
        imgList: [
            Template8_2,
            Template8_3,
            Template8_4,
            Template8_5,
            Template8_6,
            Template8_7,
            Template8_8,
            Template8_9,
            Template8_10,
        ],
    },
    {
        id: 'kdjzibeon3repy5ay4ip9akz5h',
        cover: Template9_1,
        imgList: [
            Template9_2,
            Template9_3,
            Template9_4,
            Template9_5,
            Template9_6,
            Template9_7,
            Template9_8,
            Template9_9,
            Template9_10,
        ],
    },
    {
        id: 'yjp75jdsfbb9frnx6858ro4pgo',
        cover: Template10_1,
        imgList: [
            Template10_2,
            Template10_3,
            Template10_4,
            Template10_5,
            Template10_6,
            Template10_7,
            Template10_8,
            Template10_9,
            Template10_10,
        ],
    },
    {
        id: 'hw9irrrbyjd9jxkh8k6gtgupye',
        cover: Template11_1,
        imgList: [
            Template11_2,
            Template11_3,
            Template11_4,
            Template11_5,
            Template11_6,
            Template11_7,
            Template11_8,
            Template11_9,
            Template11_10,
        ],
    },
    {
        id: 'ujpcqsuz1ifzxno4qckwkhkbir',
        cover: Template12_1,
        imgList: [
            Template12_2,
            Template12_3,
            Template12_4,
            Template12_5,
            Template12_6,
            Template12_7,
            Template12_8,
            Template12_9,
            Template12_10,
        ],
    },
    {
        id: 'fdsgqp5mt7y9fj3qduwh7x7bjy',
        cover: Template13_1,
        imgList: [
            Template13_2,
            Template13_3,
            Template13_4,
            Template13_5,
            Template13_6,
            Template13_7,
            Template13_8,
            Template13_9,
            Template13_10,
        ],
    },
    {
        id: '4wo77tdatif1zkf5up7jagxk9w',
        cover: Template14_1,
        imgList: [
            Template14_2,
            Template14_3,
            Template14_4,
            Template14_5,
            Template14_6,
            Template14_7,
            Template14_8,
            Template14_9,
            Template14_10,
        ],
    },
    {
        id: 'nagpdhr1t7f5bfz8ouwztpjxgw',
        cover: Template15_1,
        imgList: [
            Template15_2,
            Template15_3,
            Template15_4,
            Template15_5,
            Template15_6,
            Template15_7,
            Template15_8,
            Template15_9,
            Template15_10,
        ],
    },
    {
        id: 'o5uw7qdih7bi3drcb1jn4cqo9h',
        cover: Template16_1,
        imgList: [
            Template16_2,
            Template16_3,
            Template16_4,
            Template16_5,
            Template16_6,
            Template16_7,
            Template16_8,
            Template16_9,
            Template16_10,
        ],
    },
    {
        id: 'g4cp6mxhy78uudam11m8zmqt9y',
        cover: Template1_1,
        imgList: [
            Template1_2,
            Template1_3,
            Template1_4,
            Template1_5,
            Template1_6,
            Template1_7,
            Template1_8,
            Template1_9,
            Template1_10,
        ],
    },
    {
        id: '1conbzikijrczy9ypxfn8ygnta',
        cover: Template2_1,
        imgList: [
            Template2_2,
            Template2_3,
            Template2_4,
            Template2_5,
            Template2_6,
            Template2_7,
            Template2_8,
            Template2_9,
            Template2_10,
        ],
    },
    {
        id: 'rmag5z4xstrt3qh7pqi4i7zhzr',
        cover: Template3_1,
        imgList: [
            Template3_2,
            Template3_3,
            Template3_4,
            Template3_5,
            Template3_6,
            Template3_7,
            Template3_8,
            Template3_9,
            Template3_10,
        ],
    },
    {
        id: 'wcihqg1n4jgz7pwewmrddotw8w',
        cover: Template4_1,
        imgList: [
            Template4_2,
            Template4_3,
            Template4_4,
            Template4_5,
            Template4_6,
            Template4_7,
            Template4_8,
            Template4_9,
            Template4_10,
        ],
    },
    {
        id: 'rip96cw6o7yyfqkqihdqp7wzia',
        cover: Template5_1,
        imgList: [
            Template5_2,
            Template5_3,
            Template5_4,
            Template5_5,
            Template5_6,
            Template5_7,
            Template5_8,
            Template5_9,
            Template5_10,
        ],
    },
    {
        id: 'ofidqcx4cjbazcx6nnrq4sfx3o',
        cover: Template6_1,
        imgList: [
            Template6_2,
            Template6_3,
            Template6_4,
            Template6_5,
            Template6_6,
            Template6_7,
            Template6_8,
            Template6_9,
            Template6_10,
        ],
    },
];

const TEMPLATE_LIST2: ITemplate[] = [
    {
        id: 'te73nqni63d6jqp7wp3cfrgq5e',
        needVip: true,
    },
    {
        id: 'empozzjncfffups8kdxyn5g5we',
        needVip: true,
    },
    {
        id: 'c6zeehz7g3rgjbk73ucth5jrie',
        needVip: true,
    },
    {
        id: 'kdkweb6867gj3caxwa7qc46tzc',
        needVip: true,
    },
    {
        id: 'u16hrdj1jbyttji83wyybwjmcr',
        needVip: true,
    },
    {
        id: 'emm9ijdogtycfqxd3rrug7f7no',
        needVip: true,
    },
    {
        id: '30723',
        needVip: true,
    },
    {
        id: 'xkpei4i6etbqjbmrbqipbj5zmr',
        needVip: true,
    },
    {
        id: 'uj6jjmb8mig3tqzd1b8drtds5o',
        needVip: true,
    },
    {
        id: '30713',
        needVip: true,
    },
    {
        id: 'aij1hbsw1b8z5g754t6qswgoqr',
        needVip: true,
    },
    {
        id: 'hccfypzoz7fsfdn3hmc7eoq14a',
        needVip: true,
    },
    {
        id: '30717',
        needVip: true,
    },
    {
        id: '32553',
    },
    {
        id: 'zqf9pnjznbgc8pwksq7ebgiyic',
        needVip: true,
    },
    {
        id: '7u5ci68mi3bc8byswo8hgank5r',
        needVip: true,
    },
];

export const DARK_TEMPLATE: ITemplate[] = [TEMPLATE_LIST[1], TEMPLATE_LIST[13], TEMPLATE_LIST[14], TEMPLATE_LIST[15]];

export const SIMPLE_TEMPLATE: ITemplate[] = [TEMPLATE_LIST[10], TEMPLATE_LIST[11], TEMPLATE_LIST[12]];

export const MODERN_TEMPLATE: ITemplate[] = [
    TEMPLATE_LIST[0],
    TEMPLATE_LIST[2],
    TEMPLATE_LIST[3],
    TEMPLATE_LIST[4],
    TEMPLATE_LIST[5],
    TEMPLATE_LIST[6],
    TEMPLATE_LIST[7],
    TEMPLATE_LIST[8],
    TEMPLATE_LIST[9],
];

export const FEATURED_TEMPLATE: ITemplate[] = [
    TEMPLATE_LIST[0],
    TEMPLATE_LIST[2],
    TEMPLATE_LIST2[0],
    TEMPLATE_LIST2[1],
    TEMPLATE_LIST2[2],
    TEMPLATE_LIST2[3],
];

export const SUMMARY_TEMPLATE: ITemplate[] = [
    TEMPLATE_LIST2[4],
    TEMPLATE_LIST2[5],
    TEMPLATE_LIST2[6],
    TEMPLATE_LIST2[7],
    TEMPLATE_LIST2[8],
    TEMPLATE_LIST2[9],
];

export const HOT_WORKPLACE_TEMPLATE: ITemplate[] = [
    TEMPLATE_LIST2[10],
    TEMPLATE_LIST2[11],
    TEMPLATE_LIST2[12],
    TEMPLATE_LIST2[13],
    TEMPLATE_LIST2[14],
    TEMPLATE_LIST2[15],
];
